export default __webpack_public_path__ + "static/media/Talal-Shakerchi.458273da.png";